module.exports = "/images/myprofile.svg";